import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Loader = ({ message = "Loading..." }) => (
    <Box
        sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0, 0, 0, 0.4)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 2,
        }}
    >
        <CircularProgress color="secondary" />
    </Box>
);

export default Loader;